import getConfig from 'next/config';

import { isElectron } from './electron';

const { publicRuntimeConfig } = getConfig();

let SCRIBE_API_URL = publicRuntimeConfig.scribeApiRootUrl;

// TODO(apodolny): Remove when URL is whitelisted.
// This is a hack to handle a firewall issue related to a client.
if (isElectron()) {
  SCRIBE_API_URL = SCRIBE_API_URL.replace('scribehow.com', 'cursive.io');
}

export { SCRIBE_API_URL };
